/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

import { Basic, ImagingStudy, OperationOutcome, Patient } from 'fhir/r4';

/**
 * @author 212767271 Peter Szanka
 */
export interface FhirCastResource {
  timestamp: Date;
  id: string;
  event: FhirCastEvent;
}

export interface FhirCastEvent {
  'hub.topic': string;
  'hub.event': FhirHubEvent;
  context: ContextItem[];
}

export interface ContextItem {
  key: 'basic' | 'patient' | 'study' | 'extension' | 'syncerror' | 'operationoutcome';
  resource: Patient | ImagingStudy | Priors | OperationOutcome | Basic;
}

export interface Priors {
  priors: ImagingStudy[];
}

export enum FhirHubEvent {
  IMAGINGSTUDY_OPEN = 'imagingstudy-open',
  IMAGINGSTUDY_SELECT = 'imagingstudy-select',
  IMAGINGSTUDY_CLOSE = 'imagingstudy-close',
  USER_LOGOUT = 'userLogout',
  SYNC_ERROR = 'syncerror',
  SYNC_SUCCESS = 'syncsuccess',
  HOME_OPEN = 'home-open',
  CLOSE_ALL = 'close-all'
}

export type IMAGINGSTUDY_EVENT = FhirHubEvent.IMAGINGSTUDY_OPEN | FhirHubEvent.IMAGINGSTUDY_SELECT | FhirHubEvent.IMAGINGSTUDY_CLOSE;
